import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Login from '@/views/Login'
import Register from '@/views/Register'
import Purchase from '@/views/Purchase'
import store from './store'
import Shop from '@/components/Webflow/Shop.vue'
import DetailProduct from '@/components/Webflow/DetailProduct.vue'
import Login from '@/components/Webflow/Login'
import SignUp from '@/components/Webflow/SignUp.vue'
import SignUpStep1 from '@/components/Webflow/SignUpStep1.vue'
import SignUpStep2 from '@/components/Webflow/SignUpStep2.vue'
import SignUpStep3 from '@/components/Webflow/SignUpStep3.vue'
import SignUpCancel from '@/components/Webflow/SignUpCancel.vue'
import SignUpComplete from '@/components/Webflow/SignUpComplete.vue'
import Dashboard from '@/components/Webflow/user/dashboard'
import BackupDashboard from '@/components/Webflow/user/BackupDashboard'
// new pages
import NewProfile from '@/components/Webflow/newProfile'
import EditProfile from '@/components/Webflow/EditProfile'
import EditCreditCard from '@/components/Webflow/EditCreditCard'
import CreditCard from '@/components/Webflow/CreditCard'

// account pages
import Account from '@/components/Webflow/user/Account'
import AccountOrders from '@/components/Webflow/user/AccountOrders'
import AccountOrdersTracked from '@/components/Webflow/user/AccountOrdersTracked'
import AccountProfiles from '@/components/Webflow/user/AccountProfiles'
import Terms from '@/components/Webflow/Terms'
import TermsPage from '@/components/Webflow/TermsPage'

// import Cancel from '@/components/Cancel'

import AccountOrderTable from '@/components/Webflow/user/AccountOrderTable'
// import CardForm from '@/components/Vue-CC/CardForm.vue'
import CardPage from '@/components/CardPage'


import Index from '@/components/Webflow/Index'

import SignUpStep2Old from '@/components/Webflow-Old/SignUpStep2'
import Landing from '@/components/Landing'

import Forgot from '@/components/Webflow/Forgot'
import Reset from '@/components/Webflow/Reset'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/forgot',
      component: Forgot
    },
    {
      path: '/reset/:hash',
      component: Reset
    },
    {
      path: '/terms',
      component: TermsPage
    },
    {
      path: '/cardForm',
      component: CardPage
    },
    {
      path: '/how-it-works',
      component: Landing
    },
    {
      path: '/user/account',
      component: Account

    },
    {
      path: '/tts',
      component: Terms
    },
    {
      path: '/index',
      component: Index
    },
    {
      path: '/user/orders',
      component: AccountOrderTable
    },
    {
      path: '/user/ordersTracked',
      component: AccountOrdersTracked
    },
    {
      path: '/user/profiles',
      component: AccountProfiles
    },
    {
      path: '/',
      component: Index,
      meta: {
        title: 'Supreme Access'
      }
      // name: 'home',
      // component: Index
    },
    {
      path: '/newProfile',
      component: NewProfile,
      meta: {
        title: 'Supreme Access | New Profile'
      }
    },
    {
      path: '/editProfile/:id',
      component: EditProfile,
    },
    {
      path: '/creditCard',
      component: CreditCard,
    },
    {
      path: '/EditCreditCard',
      component: EditCreditCard

    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      meta: {
        title: 'Supreme Access | Signup'
      }
    },
    {
      path: '/signup1',
      name: 'signup1',
      component: SignUpStep1,
      meta: {
        title: 'Supreme Access | Signup'
      }

    },
    {
      path: '/signup2old',
      component: SignUpStep2Old

    },

    {
      path: '/signup2',
      name: 'signup2',
      component: SignUpStep2,
      meta: {
        title: 'Supreme Access | Signup'
      }
    },
    {
      path: '/signup3',
      name: 'signup3',
      component: CardPage || SignUpStep3,
      meta: {
        title: 'Supreme Access | Signup'
      }
    },
    {
      path: '/signupcancel',
      name: 'signupcancel',
      component: SignUpCancel,
      meta: {
        title: 'Supreme Access | Signup'
      }


    },
    {
      path: '/signupcomplete',
      name: 'signupcomplete',
      component: SignUpComplete,
      meta: {
        title: 'Supreme Access | Signup'
      }
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop,
      meta: {
        title: 'Supreme Access | Shop'
      }

    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: BackupDashboard,
      meta: {
        title: 'Supreme Access | Dashboard'
      }


    },
    {
      path: '/bdashboard',
      component: BackupDashboard
    },
    {
      path: '/admin',
      name: 'admin',
      component: Home,
      meta: {
        title: 'Supreme Access | Admin'
      }

    },
    {
      path: '/product',
      name: 'product',
      component: DetailProduct,
      meta: {
        title: 'Supreme Access | Product'
      }

    },
    {
      path: '/demo',
      component: Home
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: Purchase
    },

    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title
  // next()
  // return next()
  // redirect to login if not logged in trying to access restricted page

  let publicPages = ['/login', '/signup', '/demo', '/purchase', '/index', '/', '/tts', '/how-it-works', 'terms', '/forgot', '/reset']
  let protectedPages = [
    '/shop',
    '/admin',
    '/dashboard'
  ]
  // all /user routes will be protectedPages too
  let authRequired = !publicPages.includes(to.path)
  if (to.path.indexOf('reset') != -1) authRequired = false
  // let authRequired = false || protectedPages.includes(to.path)
  // if(!authRequired && to.path.startsWith('/user/') authRequired = true
  let loggedIn = localStorage.getItem('user')
  if (to.path == '/logout') {
    console.log('logging out ...')
    store.dispatch('auth/logout')

    return next('/login')
  }
  if (to.path == '/login' && loggedIn) {
    return next('/')
  }
  if (to.path == '/signup' && loggedIn) {
    return next('/')
  }
  if (authRequired && !loggedIn) {
    // return next() // for now no protected pages
    return next('/login');
  }
  return next()
})


export default router
